import { decode, encode } from './coding';

function load(name) {
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)',
    ),
  );
  return decode(matches && matches[1]);
}

function save(name, value, options) {
  options = options || {};

  let expires = options.expires;

  if (typeof expires === 'number' && expires) {
    let d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  let tokenValue = value ? encode(value) : '';
  let updatedCookie = name + '=' + tokenValue;

  for (let propName in options) {
    updatedCookie += '; ' + propName;
    let propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += '=' + propValue;
    }
  }

  document.cookie = updatedCookie;
}

function remove(name) {
  save(name, null, {
    path: '/',
    expires: -1,
  });
}

const createCookies = () => ({ load, save, remove });

export default createCookies;



// WEBPACK FOOTER //
// ./src/tools/cookie.js